import Enumerator from './Enumerator';

export const personalTitles = ['none', 'mr', 'ms', 'mrs', 'miss', 'dr'];

export class PersonalTitle extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'mr';
        break;
      case '2':
        correctOption = 'ms';
        break;
      case '3':
        correctOption = 'mrs';
        break;
      case '4':
        correctOption = 'dr';
        break;
      case '5':
        correctOption = 'miss';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

PersonalTitle.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  mr: {
    get title() {
      return 'Mr';
    }
  },
  ms: {
    get title() {
      return 'Ms';
    }
  },
  mrs: {
    get title() {
      return 'Mrs';
    }
  },
  miss: {
    get title() {
      return 'Miss';
    }
  },
  dr: {
    get title() {
      return 'Dr';
    }
  }
});

export default {
  personalTitles,
  PersonalTitle
};
